import { Button, ModalStyle as Modal, toastSuccess } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"

import { useDeleteCatalogMutation } from "shared/hooks/mutations"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { ICatalogSummary } from "shared/hubrise/models"

interface DeleteModalContentProps {
  catalogSummary: ICatalogSummary
  catalogSummaries: Array<ICatalogSummary>
  close: () => void
  redirectAfterDelete: string | undefined
}

const DeleteModalContent = ({ catalogSummary, close, redirectAfterDelete }: DeleteModalContentProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()

  const mutation = useDeleteCatalogMutation({
    onSuccess: (_, { catalogHrId }) => {
      if (redirectAfterDelete !== undefined) navigate(redirectAfterDelete)
      toastSuccess(t("catalogs.actions.delete.success", { catalogHrId }))
    },
  })

  const handleSubmit = () => {
    mutation.mutate({ catalogHrId: catalogSummary.id })
    close()
  }

  return (
    <>
      <Modal.Header>
        <Modal.Title>{t("catalogs.actions.delete.title")}</Modal.Title>
        <Modal.Close onClick={close} />
      </Modal.Header>

      <Modal.Body>{t("catalogs.actions.delete.warning")}</Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={handleSubmit}>
          {t("catalogs.actions.delete.action")}
        </Button>
        <Button variant="empty" onClick={close}>
          {t("general.cancel")}
        </Button>
      </Modal.Footer>
    </>
  )
}

export default DeleteModalContent
